import type {
  CreateUpdatePriorityRequestDto,
  GetPrioritiesResponseDto,
  PriorityDto,
  RemovePriorityResponseDto,
} from 'shared/dtos/priorities.dto';

import { ApiService } from './api.service';

export default class PrioritiesService extends ApiService {
  public getPriorities = async (): Promise<GetPrioritiesResponseDto> => {
    return await this.get(`/priorities`);
  };

  public getPriorityById = async (id: number): Promise<PriorityDto> => {
    return await this.get(`/priorities/${id}`);
  };

  public updatePriority = async (
    id: number,
    formData: CreateUpdatePriorityRequestDto,
  ): Promise<PriorityDto> => {
    const requestBody = {
      title: formData.title,
      description: formData.description,
      PolicyId: formData.PolicyId,
    };

    return await this.put(`/priorities/${id}`, requestBody);
  };

  public createPriority = async (
    formData: CreateUpdatePriorityRequestDto,
  ): Promise<PriorityDto> => {
    const requestBody = {
      title: formData.title,
      description: formData.description,
      PolicyId: formData.PolicyId,
    };

    return await this.post('/priorities/', requestBody);
  };

  public removePriority = async (
    id: number,
  ): Promise<RemovePriorityResponseDto> => {
    return await this.remove(`/priorities/${id}`);
  };
}
